import { fromJS } from 'immutable';

import {
  VALUE_CHANGED,
  LOAD,
  NEXT,
  RESET,
  RESET_DAMAGED_LOST_EXPENSE,
  RESET_DELAYED_LUGGAGE_EXPENSE,
  RESET_COMPENSATION,
} from './constants';

// The initial state of the App
const initialState = fromJS({
  form: {
    // claimForPassportCreditCard: 'false',
    // claimForTheftOfCash: 'false',
    // claimForLuggageAndPersonalEffect: 'false',
    // howItHappened: '',

    // Are you claiming for Lost Sports Equipment Rental?
    areYouClaimingForLostSportsEquipmentRental: 'false',
    nameOfTourOperatorOrCruiseOrLineOrAirlineForLostSportsEquipmentRental: '',
    scheduledDateOfDepartureForLostSportsEquipmentRental: '',
    scheduledDateOfReturnForLostSportsEquipmentRental: '',
    originationForLostSportsEquipmentRental: '',
    flightNumberOriginationForLostSportsEquipmentRental: '',
    airCarrierOriginationForLostSportsEquipmentRental: '',
    destinationForLostSportsEquipmentRental: '',
    flightNumberDestinationForLostSportsEquipmentRental: '',
    airCarrierDestinationForLostSportsEquipmentRental: '',
    dateOfLossForLostSportsEquipmentRentalInfo: '',
    placeOfLossForLostSportsEquipmentRentalInfo: '',
    addressForLostSportsEquipmentRentalInfo: '',
    contactForLostSportsEquipmentRentalInfo: '',
    phoneForLostSportsEquipmentRentalInfo: '',
    pleaseDescribeWhatOccurredForLostSportsEquipmentRentalInfo: '',
    companyNameForLostSportsEquipmentRental: '',
    addressForLostSportsEquipmentRental: '',
    typeOfPolicyForLostSportsEquipmentRental: '',
    policyForLostSportsEquipmentRental: '',
    contactForLostSportsEquipmentRental: '',
    phoneForLostSportsEquipmentRental: '',
    additionalLostSportsEquipmentRentalItems: [],
    // Are you claiming for lost items?
    areYouClaimingForLostSportsEquipment: 'false',
    nameOfTourOperatorOrCruiseOrLineOrAirlineLostSportsEquipment: '',
    scheduledDateOfDepartureLostSportsEquipment: '',
    scheduledDateOfReturnLostSportsEquipment: '',
    originationLostSportsEquipment: '',
    flightNumberOriginationLostSportsEquipment: '',
    airCarrierOriginationLostSportsEquipment: '',
    destinationLostSportsEquipment: '',
    flightNumberDestinationLostSportsEquipment: '',
    airCarrierDestinationLostSportsEquipment: '',
    dateOfLossLostSportsEquipmentInfo: '',
    placeOfLossLostSportsEquipmentInfo: '',
    addressLostSportsEquipmentInfo: '',
    contactLostSportsEquipmentInfo: '',
    phoneLostSportsEquipmentInfo: '',
    pleaseDescribeWhatOccurredLostSportsEquipmentInfo: '',
    companyNameLostSportsEquipment: '',
    addressLostSportsEquipment: '',
    typeOfPolicyLostSportsEquipment: '',
    policyLostSportsEquipment: '',
    contactLostSportsEquipment: '',
    phoneLostSportsEquipment: '',
    expenseItemsLostSportsEquipment: [],
    // Are you claiming for lost items?
    areYouClaimingForSportsEquipmentDelay: 'false',
    nameOfTourOperatorOrCruiseOrLineOrAirlineSportsEquipmentDelay: '',
    scheduledDateOfDepartureSportsEquipmentDelay: '',
    scheduledDateOfReturnSportsEquipmentDelay: '',
    originationSportsEquipmentDelay: '',
    flightNumberOriginationSportsEquipmentDelay: '',
    airCarrierOriginationSportsEquipmentDelay: '',
    destinationSportsEquipmentDelay: '',
    flightNumberDestinationSportsEquipmentDelay: '',
    airCarrierDestinationSportsEquipmentDelay: '',
    dateOfLossSportsEquipmentDelayInfo: '',
    placeOfLossSportsEquipmentDelayInfo: '',
    addressSportsEquipmentDelayInfo: '',
    contactSportsEquipmentDelayInfo: '',
    phoneSportsEquipmentDelayInfo: '',
    pleaseDescribeWhatOccurredSportsEquipmentDelayInfo: '',
    companyNameSportsEquipmentDelay: '',
    addressSportsEquipmentDelay: '',
    typeOfPolicySportsEquipmentDelay: '',
    policySportsEquipmentDelay: '',
    contactSportsEquipmentDelay: '',
    phoneSportsEquipmentDelay: '',
    expenseItemsSportsEquipmentDelay: [],
  },
  errors: [],
});

const initialDelayedLuggageExpenseState = {
  form: {
    claimForDelayLuggage: 'false',
    dateLuggageDelay: '',
    timeLuggageDelay: null,
    dateLuggageReturn: '',
    timeLuggageReturn: null,
    paidForDelay: 'false',
    madeClaimWithTravelProviderOrOther: 'false',
    listedOnThePolicy: 'false',
    delayedLuggageExpenses: [],
    dateCompensationWasReceived: '',
    compensationDescription: '',
    amountOfCompensation: '',
    amountOfCompensationCurrency: '',
  },
};

const initialDamagedLostStolenExpenseState = {
  form: {
    claimForDamagedLostOrStolenLuggageTravelDocumentOrCash: 'false',
    claimForPassportCreditCard: 'false',
    claimForTheftOfCash: 'false',
    claimForLuggageAndPersonalEffect: 'true',
    howItHappened: '',
    additionalItems: [],
  },
};

const emptyCompensationExpense = {
  form: {
    amountOfCompensation: '',
    amountOfCompensationCurrency: '',
    dateCompensationWasReceived: '',
    compensationDescription: '',
  },
};

function sportsEquipmentStepReducer(state = initialState, action) {
  const properties = action.propertyName ? action.propertyName.split('.') : '';
  switch (action.type) {
    case VALUE_CHANGED:
      return state.setIn(properties, action.value);
    case LOAD:
      return action.payload
        ? fromJS({ form: action.payload, errors: [] })
        : initialState;
    case NEXT:
      return state.merge({ errors: action.errors });
    case RESET:
      return initialState;
    case RESET_DAMAGED_LOST_EXPENSE:
      return state
        .setIn(['form', 'additionalItems'], [])
        .mergeDeep(initialDamagedLostStolenExpenseState);
    case RESET_DELAYED_LUGGAGE_EXPENSE:
      return state
        .setIn(['form', 'delayedLuggageExpenses'], [])
        .mergeDeep(initialDelayedLuggageExpenseState);
    case RESET_COMPENSATION:
      return state.mergeDeep(emptyCompensationExpense);
    default:
      return state;
  }
}

export default sportsEquipmentStepReducer;



// WEBPACK FOOTER //
// ./app/containers/FastCover/Trawick.NationWide.SportsEquipmentStep/reducer.js